<template lang="html">
  <v-layout row wrap>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="mail_outline"
        :title="titleTotalMailsSent"
        sub-title="Sent mails"
        color="deep-purple lighten-4"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="supervisor_account"
        :title="titleResponses"
        :sub-title="subTitleResponses"
        color="blue lighten-4"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="drafts"
        :title="titleOpened"
        :sub-title="subTitleOpened"
        color="pink lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="network_check"
        :title="titleNps"
        sub-title="NPS"
        :color="stats.nps >= 0 ? 'light-green lighten-3' : 'red lighten-3'"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="done_all"
        :title="titleCompleted"
        :sub-title="subTitleCompleted"
        color="green lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_very_dissatisfied"
        :title="titleDetractors"
        sub-title="Detractors"
        color="red lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_dissatisfied"
        :title="titlePassives"
        sub-title="Passives"
        text-no-wrap
        color="lime lighten-3"
      ></mini-statistic>
    </v-flex>
    <v-flex lg3 sm6 xs12>
      <mini-statistic
        icon="sentiment_very_satisfied"
        :title="titlePromotors"
        sub-title="Promotors"
        color="green lighten-3"
      ></mini-statistic>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapGetters } from 'vuex';
import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
export default {
  components: {
    MiniStatistic
  },
  props: {
    round_id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      stats: {}
    };
  },
  computed: {
    ...mapGetters('survey', ['selectedSurvey']),
    titleTotalMailsSent: function () {
      return this.stats.sent_mails ? `${this.stats.sent_mails}` : '0';
    },
    titleResponses: function () {
      return this.stats.responses ? `${this.stats.responses}` : '0';
    },
    subTitleResponses: function () {
      return this.stats.average_response ? `Responses (${this.stats.average_response}%) ` : 'Responses (0%)';
    },
    titleOpened: function () {
      return this.stats.opened ? `${this.stats.opened}` : '0';
    },
    subTitleOpened: function () {
      return this.stats.average_opened ? `Opened (${this.stats.average_opened}%) ` : `Opened (0%)`;
    },
    titleNps: function () {
      return this.stats.nps ? `${this.stats.nps}` : '0';
    },
    titleCompleted: function () {
      return this.stats.total_completed ? `${this.stats.total_completed}` : '0';
    },
    subTitleCompleted: function () {
      return this.stats.average_completed ? `Completed ${this.stats.total_completed}(${this.stats.average_completed}%)` : 'Completed 0 (0%)';
    },
    titleDetractors: function () {
      return this.stats.detractors ? `${this.stats.detractors}` : '0';
    },
    titlePassives: function () {
      return this.stats.passives ? `${this.stats.passives}` : '0';
    },
    titlePromotors: function () {
      return this.stats.promotors ? `${this.stats.promotors}` : '0';
    }
  },
  
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      const round_id = this.round_id;
      const url = `rounds/${this.round_id}/stats-mailing`;
      window.axios.get(url).then(response => {
        this.stats = response.data.data;
      });
    }
  }
};
</script>
<style>
  .caption{
    font-weight: 400px;
    white-space: nowrap;
  }
</style>


// WEBPACK FOOTER //
// src/components/client/rounds/stats/StatsMailing.vue